import api from '../../api/api'
import url from '../../api/env'
import Utils from '../../utils/Utils'

const read = async (filterName, pageNumber, excludeChars = true, sort_type = 'desc') =>
  api  
    .get(excludeChars ? `${url.stage.fels}?sort_type=${sort_type}&per_page=${pageNumber}&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.fels}?sort_type=${sort_type}&per_page=${pageNumber}&name=%${filterName}%`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const readByFelId = async felId =>
  api
    .get(`${url.stage.fels}/${felId}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const felNextPage = async urlNextPage =>
  api
    .get(`${urlNextPage}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const felDelete = async felId =>
  api
    .remove(`${url.stage.fels}/${felId}`, {})
    .then(res => res)
    .catch(err => err)

const saveFel = async data =>
  api
    .post(url.stage.fels, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const updateFel = async (data, felId) =>
  api
    .put(`${url.stage.fels}/${felId}`, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

export default {
  read,
  readByFelId,
  felNextPage,
  felDelete,
  saveFel,
  updateFel,
}
